export class ResourceTableRow {
    public columnName: string;
    public columnSpan: number;
    public showFromScreenSize: number;
    public captionLocaleKey: string;
    public fieldValue: string;

    public static create(obj: any, fieldValue: any): ResourceTableRow {
        const { columnName, captionLocaleKey, showFromScreenSize, columnSpan } = obj;
        return new ResourceTableRow(columnName, fieldValue, captionLocaleKey, showFromScreenSize, columnSpan);
    }

    constructor(columnName: string, fieldValue: string, captionLocaleKey: string, showFromScreenSize: number, columnSpan: number) {
        this.columnName = columnName;
        this.showFromScreenSize = showFromScreenSize;
        this.columnSpan = columnSpan;

        this.captionLocaleKey = captionLocaleKey;
        this.fieldValue = fieldValue;
    }
}
